import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }
  
  html, body {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    background-color: ${props => props.isDarkMode ? '#1a202c' : '#f5f7fb'};
    color: ${props => props.isDarkMode ? '#e2e8f0' : '#333'};
    transition: background-color 0.3s ease, color 0.3s ease;
  }
  
  #root {
    width: 100%;
    min-height: 100vh;
    overflow-x: hidden;
  }
  
  @media (max-width: 768px) {
    html {
      -webkit-text-size-adjust: 100%;
      -ms-text-size-adjust: 100%;
    }
    
    body {
      -webkit-overflow-scrolling: touch;
      overflow-x: hidden;
    }
  }
`;

export default GlobalStyle;
